import { render, staticRenderFns } from "./PackDeleteConfirmation.vue?vue&type=template&id=ea5163a0"
import script from "./PackDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./PackDeleteConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports